<div class="main__container">

	<breadcrumb></breadcrumb>

	<div class="section__container">
		<div class="box__container titulo__container">
			<p class="titulo">Mesa de Ayuda</p>

			<div class="card-container">
				<ng-container *ngFor="let config of cardsConfig">
					<ng-container *ngTemplateOutlet="card; context config"></ng-container>
				</ng-container>
			</div>
		</div>
	</div>

</div>


<!-- Card -->
<ng-template #card let-title="title" let-class="class" let-desc="desc" let-links="links">
	<div class="card__container">
		<div class="card">
			<div class="content">
				<div class="card__intro">
					<div class="card__icon" [ngClass]="class"></div>
					<div class="card__title">{{title}}</div>
				</div>
				<div class="card__content">
					<p class="card__desc">{{desc}}</p>
					<hr class="card__sep">
					<ng-container *ngIf="links.length > 0">
						<ng-container *ngFor="let link of links">
							<p class="card__accion" [managedLink]="link.url">{{link.text}}</p>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="links.length == 0">
						<div class="proximamente"><div>Próximamente</div></div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</ng-template>
